// extracted by mini-css-extract-plugin
module.exports = {"InnerCard":"InnerCard_InnerCard__1_wLt","middle":"InnerCard_middle__Z7v3a","title":"InnerCard_title__3kicV","content":"InnerCard_content__1vazS"};